import dayjs from '../../dayjs';
import { DateType } from '../types'

/**
 * @description: 获取当前年份的10年份范围
 * @param {DateType| Dayjs date
 * @return {*}
 */
export function getCurrentUpYear(date?: DateType) {
  const year = (!!date ? dayjs(date).year() : dayjs().year())
  return year - year % 10
}
